import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageMeta } from '../../utils/pageMeta';
import { getLekcijeAndPitanjaByPodoblastId, getPodoblastById } from '../../server/server-kategorije-tree';
import { useUser } from '../../auth/UseUser';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { Oval } from 'react-loader-spinner';
import { ObrazovanjeItem } from './ObrazovanjeHome';
import { MarkDownView } from '../common/MarkDownView';

function PodoblastObrazovanjeHome() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { navLista, setNavLista, returnedList, setReturnedList, setTipEtiteta } = useUser();
    const [mainList, setMainList] = useState<any[]>([]);
    const [podoblast, setPodoblast] = useState<any>(null);
    usePageMeta(podoblast?.naziv, podoblast?.opis, podoblast?.oblast?.naziv);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!!id) loadPodoblast();
    }, [id]);

    const loadPodoblast = async () => {
        setLoading(true);
        const resp = await getPodoblastById(id);
        if (resp.status == 200) {
            const item = resp.data;
            setPodoblast(item);
            let newList: any[] = [];
            if (item.oblast.kategorija) newList.push(item.oblast.kategorija);
            if (item.oblast.podkategorija) newList.push(item.oblast.podkategorija);
            if (item.oblast.skupOblasti) newList.push(item.oblast.skupOblasti);
            if (item.oblast) newList.push(item.oblast);
            newList.push(item);
            setNavLista(newList);
            setTipEtiteta(TypeOfEtity.Lekcija);
            setReturnedList(resp.data.lekcije);
            setMainList(resp.data.lekcije);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const loadLekcije = async (id: string | undefined) => {
        const resp = await getLekcijeAndPitanjaByPodoblastId(id);
        if (resp.status === 200) {
        }
    };

    return (
        <div className="flex-1 flex h-full flex-col items-center overflow-y-auto bg-blueDark no-scroll">
            <div className=" obrazovanje-outer-frame-mobile lg:obrazovanje-outer-frame-web">
                <div className=" obrazovanje-inner-frame-mobile sm:obrazovanje-inner-frame-web">
                    {!loading && (
                        <>
                            <p className=" text-obrazovanje-title">
                                {podoblast?.naziv}:
                                <MarkDownView
                                    source={podoblast?.opis}
                                    nazivKlase="lekcija-opis"
                                    style={{ color: 'white', textAlign: 'left', backgroundColor: 'transparent' }}
                                />
                            </p>
                            <div className="mt-6 flex flex-col gap-3">
                                {mainList.map((item: any, index: number) => {
                                    return <ObrazovanjeItem key={index} item={item} />;
                                })}
                            </div>
                        </>
                    )}
                    {loading && (
                        <div className="w-full flex-1 flex items-center justify-center">
                            <Oval />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PodoblastObrazovanjeHome;
